import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { translations } from '../../i18n'
import Loader from '../../components/Loader'

function CompetencesSection() {
  const { lang } = useSelector(s => s.rootReducer.langRed)
  const T = translations[lang]
  const { loading, categories = [] } = useSelector(s => s.rootReducer.competencesRed)

  if (loading) return <section id='competences' className='fc-section'><Container><Loader /></Container></section>

  const field = (item, base) => item[`${base}_${lang}`] || item[`${base}_en`] || ''

  return (
    <section id='competences' className='fc-section'>
      <Container>
        <h2 className='section-title'>{T.sections.competences}</h2>
        <Row>
          {categories.map(cat => (
            <Col md={6} lg={4} key={cat.id} className='mb-2'>
              <div className='comp-category'>
                <div className='comp-category-title'>{field(cat, 'name')}</div>
                <div>
                  {(cat.items || []).map(item => (
                    <span key={item.id} className='comp-badge'>{field(item, 'name')}</span>
                  ))}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default CompetencesSection
